/* eslint-disable */
class DataModel {
    constructor() {
        this.data = {};
        this.callbacks = [];
    }

    updateData(data) {
        this.data = data;
        this.callbacks.forEach(callback => callback(this.data));
    }

    getData() {
        return this.data;
    }

    onDataUpdate(callback) {
        this.callbacks.push(callback);
    }
}

export default new DataModel();
